import React, { useRef, useState } from 'react';
import ENUMS from '../../../enums';
import ShowForPermission from '../../../components/ShowForPermission';
import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';

const ReservesReportListFilter = props => {
  let formRefrence = useRef();
  let [fromDate, setFromDate] = useState(' ');
  let [toDate, setToDate] = useState(' ');
  let [cafeNamePart, setCafeNamePart] = useState();

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setCafeNamePart('');
    setFromDate(' ');
    setToDate(' ');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => props.applyFilters(event)}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div
            className="d-flex col-12 flex-sm-column flex-md-row justify-content-between p-0 align-items-center"
          >
            <div
              className="d-flex col-md-5 col-sm-12 justify-content-around mx-1 py-3 p-0"
              style={{ gap: '3px' }}
            >
              <DatePicker
                placeholder="تاریخ شروع"
                marge={true}
                name="fromDate"
                onChange={d => setFromDate(d)}
                value={fromDate}
                className="col-sm-12 col-md-6 date-picker-input"
              />
              <DatePicker
                placeholder="تاریخ پایان"
                marge={true}
                name="toDate"
                onChange={d => setToDate(d)}
                value={toDate}
                className="col-sm-12 col-md-6 date-picker-input"
              />
            </div>
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_ARCHIVE_RESERVES_FOR_ADMIN}>
              <div className="d-flex flex-column col-sm-12 col-md-4 my-2">
                <input
                  onChange={event => setCafeNamePart(event.target.value)}
                  value={cafeNamePart || ''}
                  name="cafeNamePart"
                  type="text"
                  className="form-control col-12"
                  placeholder={locales('fields.cafe.name')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                />
                <small style={{ color: '#ccc' }}>{locales('maxLength.30')}</small>
              </div>
            </ShowForPermission>
          </div>

          <div className="d-flex col-12 justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button type="submit" id="apply-filter-btn-cafeReservation" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default ReservesReportListFilter;
